import { render, staticRenderFns } from "./Mydelegate.vue?vue&type=template&id=55add834&scoped=true&"
import script from "./Mydelegate.vue?vue&type=script&lang=js&"
export * from "./Mydelegate.vue?vue&type=script&lang=js&"
import style0 from "./Mydelegate.vue?vue&type=style&index=0&id=55add834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55add834",
  null
  
)

export default component.exports